import {DEFAULT_SMOOTHING_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {getSmoothingTypeDisplayName} from '../../WorkspaceDrawer/Settings/runLinePlots/LinePlotSmoothing';
import {LinePlotDisplayFnArgs} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';

export const getSmoothingTypeDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
  isBackendSmoothingEnabled = false,
}: LinePlotDisplayFnArgs) => {
  const currTemplateSmoothingType = currTemplateLinePlotSettings?.smoothingType;

  const newTemplateSmoothingType = currWorkspaceLinePlotSettings?.smoothingType;
  const newSmoothingTypeValue =
    newTemplateSmoothingType ?? DEFAULT_SMOOTHING_SETTINGS.smoothingType;

  return {
    groupTitle: 'Smoothing',
    label: 'Smoothing type',
    field: 'smoothingType' as keyof LinePlotTemplateSettings,
    currValue: currTemplateSmoothingType,
    currDisplayValue:
      currTemplateSmoothingType == null
        ? undefined
        : getSmoothingTypeDisplayName(
            currTemplateSmoothingType,
            isBackendSmoothingEnabled
          ),
    newValue: newSmoothingTypeValue,
    newDisplayValue: getSmoothingTypeDisplayName(
      newSmoothingTypeValue,
      isBackendSmoothingEnabled
    ),
  };
};

export const getSmoothingWeightDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currTemplateSmoothingWeight =
    currTemplateLinePlotSettings?.smoothingWeight;

  const newTemplateSmoothingWeight =
    currWorkspaceLinePlotSettings?.smoothingWeight;
  const newSmoothingWeightValue =
    newTemplateSmoothingWeight ?? DEFAULT_SMOOTHING_SETTINGS.smoothingWeight;

  return {
    groupTitle: 'Smoothing',
    label: 'Smoothing weight',
    field: 'smoothingWeight' as keyof LinePlotTemplateSettings,
    // preserve the value that's used in db
    currValue: currTemplateSmoothingWeight,
    currDisplayValue:
      currTemplateSmoothingWeight == null
        ? undefined
        : currTemplateSmoothingWeight.toString(),
    newValue: newSmoothingWeightValue,
    newDisplayValue: newSmoothingWeightValue.toString(),
  };
};
